<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div
        v-if="showReviewClaim"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden"
      >
        <div
          class="fixed overflow-y-auto max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-3/5 w-full p-2"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div
            class="flex justify-between items-center border-b-1.5 font-bold pb-2"
          >
            <p class="text-base">Claim Details</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              alt=""
              @click="closeReview()"
            />
          </div>

          <div class="grid md:grid-cols-3 px-0.5 py-2 gap-5 mb-3">
            <div class="text-sm">
              <label class="block pb-1">Claim Type</label>
              <input
                :value="claimDetails.ClaimType"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Date Made</label>
              <input
                :value="formatDate(claimDetails.DateApplied)"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Amount</label>
              <input
                :value="claimDetails.Amount"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Status</label>
              <input
                :value="getApprovalStatus(claimDetails.Status)"
                type="text"
                disabled
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm col-span-3">
              <label class="block pb-1">Attachments</label>
              <div
                class="flex gap-2 p-2 py-3 bg-gray-200 rounded-md w-full border-1.5"
              >
                <div
                  class="flex gap-3 rounded-full p-2 justify-between items-center whitespace-nowrap flex-nowrap"
                  v-if="attachmentUrl.trim().length"
                >
                  <DocumentsDisplay
                    :delete-document-callback="deleteDocument"
                    :document="{
                      url: attachmentUrl.trim(),
                      DocumentType: 'Claim Attachment',
                    }"
                    :openPDFViewer="openPDFViewer"
                    class="bg-white"
                  ></DocumentsDisplay>
                </div>

                <p v-if="attachmentUrl.trim().length === 0">
                  No attachments found
                </p>
              </div>
            </div>
          </div>

          <ve-table
            rowKeyFieldName="Id"
            :fixed-header="true"
            :columns="columns"
            :table-data="approvalEntries"
          />
          <p
            v-if="approvalEntries.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No workflows found
          </p>
        </div>
      </div>
    </transition>

    <attachments-viewer
      :showAttachments="showAttachments"
      :attachmentUrl="attachmentUrl"
      :attachmentType="attachmentType"
      @close="showAttachments = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :docTitle="docTitle"
    ></attachments-viewer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import AttachmentsViewer from "../../utils/attachmentsViewer.vue";
import moment from "moment";
import DocumentsDisplay from "@/utils/documentsDisplay.vue";
import axios from "axios";
import decryptData from "@/utils/decrypt";
import mergePDFs from "@/utils/createPdfBlob";

export default {
  name: "ReviewClaim",
  props: [
    "showReviewClaim",
    "workflowToReview",
    "claimDetails",
    "approvalEntries",
    "attachmentUrl",
    "closeReview",
  ],
  components: {
    Loader,
    AttachmentsViewer,
    DocumentsDisplay,
  },
  data() {
    return {
      locations: [], // add locations data
      reason: "",
      loading: false,
      // locations: null,
      departments: null,
      isEditing: false,
      create_success: null,
      create_error: null,
      employees: null,
      currentAttachment: null,
      showAttachments: false,
      docTitle: "",
      attachmentType: "",
      columns: [
        {
          field: "",
          key: "a",
          title: "#",
          width: 50,
          align: "left",

          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row, column, h;
            return ++rowIndex;
          },
        },
        {
          field: "Approver",
          key: "Approver",
          title: "Approver",
          align: "left",
          edit: true,
          renderBodyCell: ({ row }) => {
            return decryptData(row.Approver, this.$decryptionKey);
          },
        },

        {
          field: "Sequence",
          key: "sequence",
          title: "Sequence",
          align: "center",
          headerAlign: "right",
          edit: true,
        },
        {
          field: "Status",
          key: "Status",
          title: "Status",
          align: "center",
          headerAlign: "right",
          edit: true,

          renderBodyCell: ({ row }) => {
            return row.Status === "Approved" ? (
              <p class="text-green-500">Approved</p>
            ) : (
              <p>
                {row.Status === "Declined" ? (
                  <span class="text-yellow-500">Declined</span>
                ) : (
                  <span class="text-blue-500">Pending</span>
                )}
              </p>
            );
          },
        },
      ],
      // table data
      tableData: [
        {
          Fullname: "",
          Sequence: null,
          Id: null,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getBase", "getToken"]),
  },
  methods: {
    handleCloseOnSuccess() {
      this.showAttachments = false;
    },
    getApprovalStatus(status) {
      switch (status) {
        case "Pending":
          return "Pending";
        case "Declined":
          return "Declined";
        case "Approved":
          return "Approved";
        default:
          break;
      }
    },
    openPDFViewer(documentUrl, title) {
      this.loading = true;
      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        responseType: "arraybuffer",
      };

      this.attachmentType = documentUrl;
      this.docTitle = title;

      axios
        .get(documentUrl, config)
        .then(async (response) => {
          this.loading = false;

          const contentDisposition = response.headers["content-disposition"];
          // console.log(response);
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

            if (fileNameMatch && fileNameMatch[1]) {
              const originalFileName = fileNameMatch[1];
              console.log("Original file name:", originalFileName);
            }
          }
          // Check if the response data is a valid PDF
          if (response.headers["content-type"] === "application/pdf") {
            // Create a URL for the Blob
            const url = await mergePDFs(response.data);

            // Set the PDF URL to attachmentUrl
            this.attachmentUrl = url;
            // alert(url);
          } else {
            // If it's not a valid PDF, it is treated as an image
            const blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            const url = URL.createObjectURL(blob);

            // Set the image URL to attachmentUrl
            this.attachmentUrl = url;
          }

          this.showAttachments = true;
        })
        .catch((error) => {
          this.loading = false;
          this.get_error = error;
          setTimeout(() => {
            this.get_error = null;
          }, 2500);
        });
    },

    // /{organization}/employee/document/{employeeDocumentId}/v1/delete
    deleteDocument(employeeDocumentId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/employee/document/${employeeDocumentId}/v1/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.del_success = response.data.StatusMessage;

              setTimeout(() => {
                this.del_success = null;
                this.reload();
              }, 2500);
            } else {
              this.del_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 2500);
          }
        );
    },

    close() {
      this.$emit("close");
    },

    created() {
      this.getEmployees();
      this.getLocations();
    },

    formatDate(dateStr) {
      return moment(dateStr).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
